import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { partners } from '@/data/partners';
import LogoMarquee from '@/components/common/LogoMarquee';

const PartnersSection = () => {
  return (
    <section className="py-20 relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-sm font-semibold text-[#398024] tracking-wider uppercase mb-3">Our Partners</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Working with specialised manufacturers
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Large-scope projects are delivered with associated world-leading engineering and industrial partners.
          </p>
        </motion.div>

        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
          <LogoMarquee items={partners} duration={36} />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <Link
            to="/partners"
            className="inline-flex items-center space-x-3 bg-[#398024]/5 border border-[#398024]/20 rounded-full px-8 py-4 hover:border-[#398024] transition-colors"
          >
            <div className="text-3xl font-bold text-[#398024]">{partners.length}</div>
            <div className="text-gray-600 font-medium">technology partners — view all</div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default PartnersSection;
